import { CardIssuer } from 'app/dataTypes/acquiring/recurrent/cards'

import LogoBankAgropromkredit from './svg/logo-bank-agropromkredit.svg'
import LogoBankAkb from './svg/logo-bank-akb.svg'
import LogoBankAlfa from './svg/logo-bank-alfa.svg'
import LogoBankBspb from './svg/logo-bank-bspb.svg'
import LogoBankDomrf from './svg/logo-bank-domrf.svg'
import LogoBankGazprom from './svg/logo-bank-gazprom.svg'
import LogoBankMetallinvest from './svg/logo-bank-metallinvest.svg'
import LogoBankMkb from './svg/logo-bank-mkb.svg'
import LogoBankMts from './svg/logo-bank-mts.svg'
import LogoBankNovicom from './svg/logo-bank-novicom.svg'
import LogoBankNull from './svg/logo-bank-null.svg'
import LogoBankOpen from './svg/logo-bank-open.svg'
import LogoBankOzoncard from './svg/logo-bank-ozoncard.svg'
import LogoBankPochta from './svg/logo-bank-pochta.svg'
import LogoBankRaiffeisen from './svg/logo-bank-raiffeisen.svg'
import LogoBankRgs from './svg/logo-bank-rgs.svg'
import LogoBankRncb from './svg/logo-bank-rncb.svg'
import LogoBankRshb from './svg/logo-bank-rshb.svg'
import LogoBankRussia from './svg/logo-bank-russia.svg'
import LogoBankSber from './svg/logo-bank-sber.svg'
import LogoBankSovcom from './svg/logo-bank-sovcom.svg'
import LogoBankTbank from './svg/logo-bank-tbank.svg'
import LogoBankUnicredit from './svg/logo-bank-unicredit.svg'
import LogoBankUralsib from './svg/logo-bank-uralsib.svg'
import LogoBankVtb from './svg/logo-bank-vtb.svg'

type Props = {
  className?: string
  issuer: CardIssuer
}

export const CardIssuerIcon = ({ className, issuer }: Props) => {
  if (issuer === CardIssuer.AKBank) return <LogoBankAkb className={className} />
  if (issuer === CardIssuer.AgroPromCredit) return <LogoBankAgropromkredit className={className} />
  if (issuer === CardIssuer.AlfaBank) return <LogoBankAlfa className={className} />
  if (issuer === CardIssuer.BSPB) return <LogoBankBspb className={className} />
  if (issuer === CardIssuer.DOMRFBank) return <LogoBankDomrf className={className} />
  if (issuer === CardIssuer.GazPromBank) return <LogoBankGazprom className={className} />
  if (issuer === CardIssuer.MKB) return <LogoBankMkb className={className} />
  if (issuer === CardIssuer.MTSBank) return <LogoBankMts className={className} />
  if (issuer === CardIssuer.MetallInvestBank) return <LogoBankMetallinvest className={className} />
  if (issuer === CardIssuer.NovikomBank) return <LogoBankNovicom className={className} />
  if (issuer === CardIssuer.OZONCard) return <LogoBankOzoncard className={className} />
  if (issuer === CardIssuer.OtkritieBank) return <LogoBankOpen className={className} />
  if (issuer === CardIssuer.PochtaBank) return <LogoBankPochta className={className} />
  if (issuer === CardIssuer.RGSBank) return <LogoBankRgs className={className} />
  if (issuer === CardIssuer.RNCB) return <LogoBankRncb className={className} />
  if (issuer === CardIssuer.RSHB) return <LogoBankRshb className={className} />
  if (issuer === CardIssuer.RaiffeisenBank) return <LogoBankRaiffeisen className={className} />
  if (issuer === CardIssuer.RosBank) return <LogoBankRussia className={className} />
  if (issuer === CardIssuer.Sber) return <LogoBankSber className={className} />
  if (issuer === CardIssuer.SberBank) return <LogoBankSber className={className} />
  if (issuer === CardIssuer.SovComBank) return <LogoBankSovcom className={className} />
  if (issuer === CardIssuer.TBank) return <LogoBankTbank className={className} />
  if (issuer === CardIssuer.TinkoffBank) return <LogoBankTbank className={className} />
  if (issuer === CardIssuer.UniCreditBank) return <LogoBankUnicredit className={className} />
  if (issuer === CardIssuer.UralSib) return <LogoBankUralsib className={className} />
  if (issuer === CardIssuer.VTB) return <LogoBankVtb className={className} />
  return <LogoBankNull className={className} />
}
